import React from 'react';
import { Text, FlexRow, formatNumber } from '@make-software/tg-mini-app-ui';

import { StyledEarnIcon } from '@/shared';
import EarnIcon from '@/shared/assets/icons/ic-earn.svg';

import { ButtonAmountText } from '../styled';

interface IButtonTitleProps {
  amount: string | number;
  isWalletConnected: boolean;
  disabled?: boolean;
}

export const ButtonTitle: React.FC<IButtonTitleProps> = ({
  amount,
  isWalletConnected,
  disabled
}) => {
  return (
    <FlexRow align="center" gap={5}>
      <Text
        weight={3}
        size="md"
        color="#FFFFFF"
        style={{ color: disabled ? '#64666B' : '#FFF' }}
        fontFamily="Inter">
        {isWalletConnected ? 'Send' : 'Connect Casper Wallet'}
      </Text>
      {Boolean(amount) && isWalletConnected && (
        <FlexRow align="center" gap={5}>
          <StyledEarnIcon src={EarnIcon} fillColor={disabled ? '#64666B' : '#FFF'} />
          <ButtonAmountText weight={3} size="md" color="#FFFFFF" monotype disabled={disabled}>
            {formatNumber(amount)}
          </ButtonAmountText>
        </FlexRow>
      )}
    </FlexRow>
  );
};
